module.exports = __webpack_public_path__ + "img/yaopin.797ac408.jpeg";